import React from 'react';
import {Helmet} from 'react-helmet';

// Keep this component outside App so responsive updates do not remount pages.
export default function RoutePage({route}) {
    const Component = route.component;
    return (
        <>
            <Helmet>
                <title>{route.title}</title>
                <meta name="description" content={route.desc ?? ''}/>
                <meta name="keywords" content={route.keywords ?? ''}/>
                <meta name="robots" content={route.robots ?? 'index, follow'}/>
                <meta name="twitter:card" content={route.twitterCard ?? 'summary'}/>
                <meta name="twitter:site" content={route.twitterSite ?? '@VieuniteHQ'}/>
                <meta name="twitter:title" content={route.twitterTitle ?? route.title ?? ''}/>
                <meta name="twitter:description" content={route.twitterDesc ?? route.desc ?? ''}/>
                <meta name="twitter:image" content={route.twitterImage ?? route.image ?? ''}/>
                {route.twitterImageAlt && (
                    <meta name="twitter:image:alt" content={route.twitterImageAlt}/>
                )}
                <meta property="og:site_name" content={route.ogSiteName ?? 'Vieunite'}/>
                <meta property="og:type" content={route.type ?? 'article'}/>
                <meta property="og:title" content={route.ogTitle ?? route.title ?? ''}/>
                <meta property="og:description" content={route.ogDesc ?? route.desc ?? ''}/>
                <meta property="og:image" content={route.ogImage ?? route.image ?? ''}/>
                {route.ogImageAlt && (
                    <meta property="og:image:alt" content={route.ogImageAlt}/>
                )}
            </Helmet>
            <Component/>
        </>
    );
}
